import { REMOVE_DELETED_DRAFT_REFERRAL } from 'actions';

export default function removeDeletedDraftReferral(draftId) {
  return {
    type: REMOVE_DELETED_DRAFT_REFERRAL,
    draftId,
  };
}
